import FavoriteView from './FavoriteView';

export default FavoriteView;
